import { Icon, IconProps } from ".";

export const WeightIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.875 5H11.125V5.875H10.25V8.5H7.625V11.125H6.75V13.75H5.875V16.375H5V19H19V16.375H18.125V13.75H17.25V11.125H16.375V8.5H13.75V5.875H12.875V5ZM12.875 5.875V7.625H11.125V5.875H12.875Z"
        fill="currentColor"
      />
    </Icon>
  );
};
